module.exports = __webpack_public_path__ + "img/icon-null.a7e18969.png";